<template>
  <div>
    <template v-if="loading">
      <div class="spinner-wrapper">
        <spinner></spinner>
      </div>
    </template>
    <template v-else>
      <h2 class="Fuell-Section--title">{{ massiveImport.office.name }}</h2>

      <div class="Fuell-Toolbar">
        <h3
          class="Fuell-Toolbar--subtitle pt-2 mr-auto"
          v-t="{ path: 'users_import_validation_description' }"
        ></h3>
        <div
          v-if="isCompleted"
          class="Fuell-Text orange mr-4"
          v-t="'users_import_already_completed'"
        ></div>
        <button
          class="Fuell-ToolbarButton red"
          :disabled="isNotConfirmed"
          type="button"
          @click="handleReject()"
        >
          <span class="Fuell-ToolbarButton--label">
            {{ $t('ACTION_REJECT') }}
          </span>
        </button>
        <button
          class="Fuell-ToolbarButton green ml-3"
          :disabled="isNotConfirmed"
          type="button"
          @click="handleAccept()"
        >
          <span class="Fuell-ToolbarButton--label">
            {{ $t('ACTION_ACCEPT') }}
          </span>
        </button>
      </div>

      <div class="Fuell-Table pb-5">
        <div :class="tableHeaderClass">
          <div class="Fuell-Table--item">
            <span v-t="{ path: 'users_import_table_name' }"></span>
          </div>
          <div class="Fuell-Table--item">
            <span v-t="{ path: 'users_import_table_email' }"></span>
          </div>
          <div class="Fuell-Table--item">
            <span v-t="{ path: 'users_identifier' }"></span>
          </div>
          <div class="Fuell-Table--item">
            <span v-t="{ path: 'users_expense_center' }"></span>
          </div>

          <div class="Fuell-Table--item">
            <span v-t="{ path: 'users_import_table_role' }"></span>
          </div>
          <div
            class="Fuell-Table--item"
            v-if="officeHasOptionalCards || officeHasPhysicalCards"
          >
            <span v-t="{path: 'users_import_table_card_emission'}"></span>
          </div>
        </div>
        <div class="Fuell-Table--content">
          <div
            :class="tableRowClass"
            v-for="user in massiveImport.data"
            :key="user.email"
          >
            <div class="Fuell-Table--item" v-tooltip="user.name">{{ user.name }} {{ user.lastName }}</div>
            <div class="Fuell-Table--item" v-tooltip="user.email">{{ user.email }}</div>
            <div class="Fuell-Table--item" v-tooltip="user.identifier">
              {{user.identifier}}
            </div>
            <div class="Fuell-Table--item" v-tooltip="user.expenseCenter">
              {{user.expenseCenter}}
            </div>
            <div class="Fuell-Table--item" v-tooltip="$t(`user_role__${user.role}`)">{{ $t(`user_role__${user.role}`) }}</div>
            <div
              class="Fuell-Table--item"
              v-if="officeHasOptionalCards || officeHasPhysicalCards"
            >
              {{checkUserCardInfo(user)}}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import customersApi from '../../_api/index'

import Spinner from '@/components/Commons/Spinner'

export default {
  name: 'MassiveImportDetails',
  components: { Spinner },
  data () {
    return {
      loading: false,
      massiveImport: null,
      hasOptionalCards: false
    }
  },
  created () {
    const { id } = this.$route.params
    this.fetchImportData(id)
  },
  computed: {
    isNotConfirmed () {
      return this.massiveImport.status !== 'CONFIRMED'
    },
    isCompleted () {
      return this.massiveImport.status === 'COMPLETED'
    },
    officeHasOptionalCards () {
      return this.hasOptionalCards === 'OFFICE_CARDS_OPTIONAL'
    },
    officeHasPhysicalCards () {
      return this.hasOptionalCards === 'OFFICE_CARDS_ALWAYS'
    },
    officeHasNoCards () {
      return this.hasOptionalCards === 'OFFICE_CARDS_WITHOUT'
    },
    tableHeaderClass () {
      return this.officeHasOptionalCards ? 'Fuell-Table--header Fuell-Table--header--optional-cards' : 'Fuell-Table--header'
    },
    tableRowClass () {
      return this.officeHasOptionalCards ? ' Fuell-Table--row Fuell-Table--row--optional-cards' : 'Fuell-Table--row'
    }
  },
  methods: {
    async fetchImportData (id) {
      this.loading = true
      try {
        const response = await customersApi.getUserMassiveImport(id)
        this.massiveImport = response.data
        this.hasOptionalCards = response.data.office.officeCardsType
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'users_import_loading_error' }, { root: true })
      } finally {
        this.loading = false
      }
    },
    handleReject () {
      customersApi.rejectMassiveImport(this.massiveImport.id)
        .then(res => res.data).then(data => {
          this.$store.dispatch('SnackBars/addSuccess', this.$t('users_import_reject_completed'))
          this.$router.push({ name: 'active_customers' })
        }).catch(error => {
          this.$store.dispatch('SnackBars/addErrorHandler', {
            error: error,
            errorMessage: 'users_import_reject_error'
          }, { root: true })
        }).finally(() => {
          this.loading = false
        })
    },
    handleAccept () {
      this.loading = true
      customersApi.confirmMassiveImport(this.massiveImport.id)
        .then(res => res.data).then(data => {
          if (data.status === 'COMPLETED') {
            this.$store.dispatch('SnackBars/addSuccess', this.$t('users_import_accept_completed'))
            this.$router.push({ name: 'active_customers' })
          }
        }).catch(error => {
          this.$store.dispatch('SnackBars/addErrorHandler', {
            error: error,
            errorMessage: 'users_import_accept_error'
          }, { root: true })
        }).finally(() => {
          this.loading = false
        })
    },
        checkUserCardInfo (user) {
      if (!user) return ''
      if (user.role === 'ROLE_BOOKKEEPER') {
        return this.$i18n.t('user_card_usage_not_applicable')
      }

      return user.userCardsType === 'USER_CARDS_ALWAYS' ? this.$i18n.t(`user_card_usage_type__${user.typeOfCardWhenRegisteredOnIssuer}`) : this.$i18n.t('customer_user_without_cards')
    }

  }
}
</script>

<style lang="scss">
@import "@/assets/styles/tables/massive-import-details.scss";

.spinner-wrapper {
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
